var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindowicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.702,
    height: 40.379,
    viewBox: "0 0 40.702 40.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "window_icon",
    "data-name": "window icon",
    transform: "translate(-1369 -533.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7358",
    "data-name": "Rectangle 7358",
    transform: "translate(1369 536)",
    fill: "#eceff1",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 38,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 36,
    height: 37,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36214",
    "data-name": "Path 36214",
    d: "M-1289.5,797.5v36.844",
    transform: "translate(2677 -261)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36216",
    "data-name": "Path 36216",
    d: "M-1308.015,820.8l4.174-2.121L-1303.8,858h-4.2Z",
    transform: "translate(2713 -284.504)",
    fill: "#ddd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36217",
    "data-name": "Path 36217",
    d: "M-1308,821h39.563l-4.369,3.081H-1308Z",
    transform: "translate(2677.502 -286.881)",
    fill: "#b1b1b1",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowicon);
export default __webpack_public_path__ + "static/media/window icon.fd8e10c9ff83f7022946ae89619cbe89.svg";
export { ForwardRef as ReactComponent };